/// <amd-module name="VSSUI/Components/ContextualMenuButton/MoreActionsButton" />

import * as React from "react";
import { IContextualMenuButtonProps } from "../../Components/ContextualMenuButton/ContextualMenuButton.Props";
import { ContextualMenuButton } from "../../Components/ContextualMenuButton/ContextualMenuButton";
import * as Preview_Resources from "VSSUI/VSS.Resources.VSSUI";

/**
 * Implementation of the ContextualMenuButton that uses the ellipsis
 */
/** @deprecated Please use import { Menu } from "VSSUI/Menu" */
export class MoreActionsButton extends React.Component<IContextualMenuButtonProps> {
    private _contextualMenuRef: ContextualMenuButton | null = null;

    public get contextualMenuRef(): ContextualMenuButton | null {
        return this._contextualMenuRef;
    }

    public render(): JSX.Element {
        return (
            <ContextualMenuButton
                showTooltip={true}
                {...this.props}
                ref={(element: ContextualMenuButton) => {
                    this._contextualMenuRef = element;
                }}
                iconProps={{ iconName: "More" }}
                title={this.props.title || Preview_Resources.MoreActionsText}
            />
        );
    }

    public componentWillUnmount(): void {
        this._contextualMenuRef = null;
    }
}
